export default function Canvas_Compositing() {
  return (
    <div>
      <h1>Canvas_Compositing Component</h1>
    </div>
  );
}
